import { apiClient } from "@/lib/api/client";

export type ReportResultColumnDto = {
  key: string;
  label: string;
};

export type ReportResultRowDto = Record<string, string | number | boolean | null>;

export type ReportResultResponseDto = {
  report_key: string;
  title: string;
  columns: ReportResultColumnDto[];
  rows: ReportResultRowDto[];
  total: number;
  limit: number;
  offset: number;
  next_offset: number | null;
};

export type ReportResultParams = {
  tenantId?: string | null;
  rangeKey?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  search?: string | null;
  deviceId?: string | null;
  stateId?: string | null;
  adminId?: string | null;
  limit?: number | null;
  offset?: number | null;
};

function toQuery(params?: ReportResultParams) {
  const query: Record<string, string | number> = {};
  if (params?.tenantId) query.tenant_id = params.tenantId;
  if (params?.rangeKey) query.range_key = params.rangeKey;
  if (params?.startDate) query.start_date = params.startDate;
  if (params?.endDate) query.end_date = params.endDate;
  if (params?.search?.trim()) query.search = params.search.trim();
  if (params?.deviceId) query.device_id = params.deviceId;
  if (params?.stateId) query.state_id = params.stateId;
  if (params?.adminId) query.admin_id = params.adminId;
  if (typeof params?.limit === "number") query.limit = params.limit;
  if (typeof params?.offset === "number") query.offset = params.offset;
  return query;
}

export async function getReportResult(reportKey: string, params?: ReportResultParams): Promise<ReportResultResponseDto> {
  const { data } = await apiClient.get<ReportResultResponseDto>(`/report-results/${reportKey}`, {
    params: toQuery(params),
  });
  return data;
}

export async function exportReportResult(reportKey: string, params?: ReportResultParams): Promise<Blob> {
  const { data } = await apiClient.get<Blob>(`/report-results/${reportKey}/export`, {
    params: toQuery(params),
    responseType: "blob",
  });
  return data;
}
